const ColorList = [
	{
		hex: "#003D79",
		color: "dark-blue",
		text: "text-dark-blue",
		bg: "bg-dark-blue",
		shadow: "shadow-dark-blue",
		border: "border-dark-blue",
		ring: "ring-dark-blue",
		name: "Dark Blue",
	},
	{
		hex: "#CD4407",
		color: "burned-orange",
		text: "text-burned-orange",
		bg: "bg-burned-orange",
		shadow: "shadow-burned-orange",
		border: "border-burned-orange",
		ring: "ring-burned-orange",
		name: "Burned Orange",
	},
	{
		hex: "#FC4242",
		color: "candy-red",
		text: "text-candy-red",
		bg: "bg-candy-red",
		shadow: "shadow-candy-red",
		border: "border-candy-red",
		ring: "ring-candy-red",
		name: "Candy Red",
	},
	{
		hex: "#255D26",
		color: "dark-green",
		text: "text-dark-green",
		bg: "bg-dark-green",
		shadow: "shadow-dark-green",
		border: "border-dark-green",
		ring: "ring-dark-green",
		name: "Dark Green",
	},
	{
		hex: "#69CBB2",
		color: "pastel-green",
		text: "text-pastel-green",
		bg: "bg-pastel-green",
		shadow: "shadow-pastel-green",
		border: "border-pastel-green",
		ring: "ring-pastel-green",
		name: "Pastel Green",
	},
	{
		hex: "#89CFF0",
		color: "sky-blue",
		text: "text-sky-blue",
		bg: "bg-sky-blue",
		shadow: "shadow-sky-blue",
		border: "border-sky-blue",
		ring: "ring-sky-blue",
		name: "Sky Blue",
	},
	{
		hex: "#A020F0",
		color: "purple",
		text: "text-purple",
		bg: "bg-purple",
		shadow: "shadow-purple",
		border: "border-purple",
		ring: "ring-sky-blue",
		name: "Purple",
	},
	{
		hex: "#000000",
		color: "black",
		text: "text-black",
		bg: "bg-black",
		shadow: "shadow-black",
		border: "border-black",
		ring: "ring-black",
		name: "Black",
	},
];

export default ColorList;
